<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="博客管理">
        <div class="row">
          <div class="flex md9 sm6 xs12">
            <va-button-group>
              <va-button class="mb-2" disabled flat color="gray">状态筛选：</va-button>
              <va-button class="mb-2" flat :color="computeSelectedStatusColor(null)" v-on:click="handleStatusChange(null)">全部</va-button>
              <va-button
                class="mb-2"
                flat
                v-for="statusType in statusTypes"
                :key="statusType.VALUE"
                :color="computeSelectedStatusColor(statusType.VALUE)"
                v-on:click="handleStatusChange(statusType.VALUE)">{{statusType.TEXT}}</va-button>
            </va-button-group>
            <va-button-group class="ml-3">
              <va-button class="mb-2" disabled flat color="gray">索引筛选：</va-button>
              <va-button class="mb-2" flat :color="computeSelectedNoIndexColor(null)" v-on:click="handleNoIndexChange(null)">全部</va-button>
              <va-button
                class="mb-2"
                flat
                v-for="noIndexType in noIndexTypes"
                :key="noIndexType.VALUE"
                :color="computeSelectedNoIndexColor(noIndexType.VALUE)"
                v-on:click="handleNoIndexChange(noIndexType.VALUE)">{{noIndexType.TEXT}}</va-button>
            </va-button-group>
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
          <div class="flex md3 xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" small outline @click="$router.push('saveBlog')">创建博客</va-button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="flex md6 xs12">
            <va-input
              v-model="keyword"
              placeholder="搜索标题或内容..."
              @input="handleSearch"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
        </div>

        <va-data-table
          :fields="fields"
          :data="blogs"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listBlog"
          api-mode
        >
          <template slot="title" slot-scope="props">
            <div class="text-left">{{ props.rowData.title }}</div>
          </template>
          <template slot="status" slot-scope="props">
            <va-badge :color="computeStatusColor(props.rowData.status)">
              {{ computeStatusText(props.rowData.status) }}
            </va-badge>
          </template>
          <template slot="noIndex" slot-scope="props">
            <va-badge :color="computeNoIndexColor(props.rowData.noIndex)">
              {{ computeNoIndexText(props.rowData.noIndex) }}
            </va-badge>
          </template>
          <template slot="score" slot-scope="props">
            <va-popover :message="computeScorePopover(props.rowData)" placement="top">
              <va-badge
                class="score-badge"
                :color="computeScoreColor(props.rowData)"
                @click.native="openScoreModal(props.rowData)"
              >
                {{ computeScoreText(props.rowData) }}
              </va-badge>
            </va-popover>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="打分" placement="top">
              <va-button
                flat
                small
                color="gray"
                icon="fa fa-star"
                :disabled="scoringId === props.rowData.id"
                @click="scoreBlog(props.rowData)"
              />
            </va-popover>
            <va-popover message="编辑" placement="top">
              <va-button flat small color="gray" icon="fa fa-pencil"
                :to='{path:`updateBlog/${props.rowData.id}`}'/>
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button message="删除" placement="top" flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true;deleteId=props.rowData.id"/>
            </va-popover>
          </template>
        </va-data-table>

        <va-modal
          v-model="deleteModal"
          title="删除博客"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

        <va-modal
          v-model="scoreModal"
          title="博客质量评分"
          okText="关闭"
          position="center"
        >
          <div v-if="scoreDetail" class="score-modal">
            <div class="score-modal__header">
              <va-badge :color="computeScoreColor(selectedScoreRow)">
                {{ displayScore(selectedScoreRow, scoreDetail) }}分 {{ scoreDetail.level || selectedScoreRow.scoreLevel || '' }}
              </va-badge>
              <va-badge :color="isScorePublishable(selectedScoreRow, scoreDetail) ? 'success' : 'danger'">
                {{ isScorePublishable(selectedScoreRow, scoreDetail) ? '允许发布' : '禁止发布' }}
              </va-badge>
            </div>
            <p class="score-modal__summary">{{ scoreDetail.summary || selectedScoreRow.scoreSummary || '暂无评分摘要' }}</p>
            <p v-if="selectedScoreRow.scoreStale" class="score-modal__warning">文章内容已修改，当前评分已过期，请重新打分。</p>
            <p v-if="scoreDetail.publishBlockReason" class="score-modal__warning">{{ scoreDetail.publishBlockReason }}</p>

            <div v-if="scoreDetail.dimensions && scoreDetail.dimensions.length" class="score-modal__section">
              <h4>维度明细</h4>
              <div v-for="dimension in scoreDetail.dimensions" :key="dimension.key" class="score-dimension">
                <div class="score-dimension__title">
                  <strong>{{ dimension.name }}</strong>
                  <span>{{ dimension.score }}/{{ dimension.weight }}</span>
                </div>
                <div class="score-dimension__text">{{ dimension.reason }}</div>
                <div class="score-dimension__fix">建议：{{ dimension.fix }}</div>
              </div>
            </div>

            <div v-if="scoreDetail.topIssues && scoreDetail.topIssues.length" class="score-modal__section">
              <h4>主要问题</h4>
              <ul>
                <li v-for="issue in scoreDetail.topIssues" :key="issue">{{ issue }}</li>
              </ul>
            </div>

            <div v-if="scoreDetail.suggestions && scoreDetail.suggestions.length" class="score-modal__section">
              <h4>修改建议</h4>
              <ul>
                <li v-for="suggestion in scoreDetail.suggestions" :key="suggestion">{{ suggestion }}</li>
              </ul>
            </div>
          </div>
        </va-modal>

      </va-card>
    </div>
  </div>
</template>

<script>

import blogApi from '../../api/blog'
import { formatTime } from '../../utils/common'

export default {
  data () {
    return {
      keyword: '',
      status: null,
      noIndex: null,
      loading: true,
      pageNumber: 1,
      pageSize: 20,
      totalPages: 1,
      totalCount: 0,
      deleteModal: false,
      deleteId: null,
      blogs: [],
      statusTypes: [
        { VALUE: 0, TEXT: '草稿' },
        { VALUE: 1, TEXT: '已发布' },
      ],
      noIndexTypes: [
        { VALUE: 0, TEXT: '允许索引' },
        { VALUE: 1, TEXT: '禁止索引' },
      ],
      searchTimer: null,
      scoringId: null,
      scoreModal: false,
      scoreDetail: null,
      selectedScoreRow: {},
      publishThreshold: 75,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:title',
          title: '标题',
          width: '25%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'author',
          title: '作者',
          width: '12%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:status',
          title: '状态',
          width: '8%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:noIndex',
          title: '索引',
          width: '8%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:score',
          title: '评分',
          width: '12%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'updateTime',
          title: '更新时间',
          width: '13%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '14%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listBlog()
  },
  methods: {
    listBlog (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageNumber: pageNumber,
        pageSize: this.pageSize,
      }
      if (this.keyword) {
        params.keyword = this.keyword
      }
      if (this.status !== null) {
        params.status = this.status
      }
      if (this.noIndex !== null) {
        params.noIndex = this.noIndex
      }
      blogApi.listBlog(params).then(response => {
        this.blogs = response.blogs
        this.blogs.forEach(x => {
          x.createTime = x.createTime ? formatTime(x.createTime) : '-'
          x.updateTime = x.updateTime ? formatTime(x.updateTime) : '-'
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => {
        this.showToast(error.msg || '获取博客列表失败', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        this.loading = false
      })
    },
    confirmDelete () {
      if (this.deleteId === null) return
      blogApi.deleteBlog(this.deleteId).then(response => {
        if (response.success === true) {
          this.showToast('删除博客成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listBlog()
        }
      }).catch(error => {
        this.showToast(error.msg || '删除博客失败', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    scoreBlog (row) {
      if (!row || !row.id) return
      this.scoringId = row.id
      blogApi.scoreBlog(row.id).then(response => {
        this.applyScoreResponse(row, response)
        this.openScoreModal(row)
        this.showToast('博客评分完成', {
          duration: 1000,
          icon: 'fa-check',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error.msg || '博客评分失败', {
          duration: 2000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).finally(() => {
        this.scoringId = null
      })
    },
    applyScoreResponse (row, response) {
      const scoreFields = [
        'score',
        'scoreLevel',
        'scoreSummary',
        'scoreDetailJson',
        'scoreModel',
        'scoreTime',
        'scoreBy',
        'scoreContentHash',
        'scoreStale',
      ]
      scoreFields.forEach(field => {
        this.$set(row, field, response[field])
      })
    },
    openScoreModal (row) {
      if (!this.hasScore(row)) return
      this.selectedScoreRow = row
      this.scoreDetail = this.parseScoreDetail(row)
      this.scoreModal = true
    },
    parseScoreDetail (row) {
      if (row.scoreDetailJson) {
        try {
          return JSON.parse(row.scoreDetailJson)
        } catch (error) {
          console.log(error)
        }
      }
      return {
        overallScore: row.score,
        level: row.scoreLevel,
        eligibleForPublish: row.score >= this.publishThreshold && !row.scoreStale,
        publishBlockReason: row.scoreStale ? '文章内容已修改，评分已过期' : '',
        summary: row.scoreSummary,
        dimensions: [],
        topIssues: [],
        suggestions: [],
      }
    },
    hasScore (row) {
      return !!row && row.score !== null && row.score !== undefined
    },
    displayScore (row, detail) {
      if (detail && detail.overallScore !== null && detail.overallScore !== undefined) {
        return detail.overallScore
      }
      return this.hasScore(row) ? row.score : '-'
    },    isScorePublishable (row, detail) {
      if (!this.hasScore(row) || row.scoreStale) return false
      if (detail && detail.eligibleForPublish === false) return false
      return row.score >= this.publishThreshold
    },
    computeScoreColor (row) {
      if (!this.hasScore(row)) return 'gray'
      if (row.scoreStale) return 'warning'
      if (row.score >= 85) return 'success'
      if (row.score >= this.publishThreshold) return 'info'
      if (row.score >= 60) return 'warning'
      return 'danger'
    },
    computeScoreText (row) {
      if (!this.hasScore(row)) return '未评分'
      const level = row.scoreLevel ? ` ${row.scoreLevel}` : ''
      return row.scoreStale ? `${row.score}分${level} 需重评` : `${row.score}分${level}`
    },
    computeScorePopover (row) {
      if (!this.hasScore(row)) return '尚未评分'
      if (row.scoreStale) return '评分已过期，点击打分重新评估'
      return '点击评分徽标查看详情，点击星标重新打分'
    },
    computeStatusColor (status) {
      const colorMap = {
        0: 'gray',
        1: 'success',
      }
      return colorMap[status] || 'gray'
    },
    computeStatusText (status) {
      const textMap = {
        0: '草稿',
        1: '已发布',
      }
      return textMap[status] || status
    },
    computeSelectedStatusColor (status) {
      return status === this.status ? 'info' : 'gray'
    },
    handleStatusChange (status) {
      this.status = status
      this.pageNumber = 1
      this.listBlog()
    },
    computeNoIndexColor (noIndex) {
      const colorMap = {
        0: 'success',
        1: 'warning',
      }
      return colorMap[noIndex] || 'gray'
    },
    computeNoIndexText (noIndex) {
      const textMap = {
        0: '允许',
        1: '禁止',
      }
      return textMap[noIndex] || noIndex
    },
    computeSelectedNoIndexColor (noIndex) {
      return noIndex === this.noIndex ? 'info' : 'gray'
    },
    handleNoIndexChange (noIndex) {
      this.noIndex = noIndex
      this.pageNumber = 1
      this.listBlog()
    },
    handleSearch () {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      this.searchTimer = setTimeout(() => {
        this.pageNumber = 1
        this.listBlog()
      }, 500)
    },
  },
}

</script>

<style lang="scss" scoped>
.text-left {
  text-align: left;
}

.score-badge {
  cursor: pointer;
}

.score-modal {
  max-width: 720px;
  line-height: 1.5;
}

.score-modal__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.score-modal__summary {
  margin-bottom: 12px;
}

.score-modal__warning {
  color: #e34a4a;
  font-weight: 600;
  margin-bottom: 12px;
}

.score-modal__section {
  margin-top: 16px;
}

.score-modal__section h4 {
  font-size: 15px;
  margin-bottom: 8px;
}

.score-dimension {
  border-bottom: 1px solid #eeeeee;
  padding: 8px 0;
}

.score-dimension__title {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 4px;
}

.score-dimension__text,
.score-dimension__fix {
  font-size: 13px;
  color: #4f5d75;
}
</style>
